import { render, staticRenderFns } from "./StaffLeads.vue?vue&type=template&id=6d0314b4&scoped=true"
import script from "./StaffLeads.vue?vue&type=script&lang=js"
export * from "./StaffLeads.vue?vue&type=script&lang=js"
import style0 from "./StaffLeads.vue?vue&type=style&index=0&id=6d0314b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0314b4",
  null
  
)

export default component.exports